import { CSSProperties, FC, ReactElement } from 'react'
import close from '../../assets/icons/close.svg'
import Button from '../button'
import { Container } from './styles'

type ModalProps = {
  isLoading?: boolean;
  children?: ReactElement | string | (string | ReactElement)[];
  title?: ReactElement | string | (string | ReactElement)[];
  footerComponent?: ReactElement | string | (string | ReactElement)[];
  style?: CSSProperties;
  okButtonText?: string;
  variantButton?: 'primary' | 'danger' | 'muted'
  onOk?: () => void;
  onClose?: () => void;
}

const Modal: FC<ModalProps> = ({
  footerComponent,
  isLoading,
  variantButton,
  onOk,
  onClose,
  style,
  title,
  children,
  okButtonText = 'Ok'
}): ReactElement => {
  return (
    <Container style={style}>
      <div className='modal_background' />
      <div className='modal_content'>
        {onClose && (
          <button className='modal_close' type='button' onClick={onClose}>
            <img src={close} alt='fechar modal' />
          </button>
        )}
        {title && <h2 className='modal_title'>{title}</h2>}
        <div className='modal_content_info'>
          {children}
        </div>
        <Button isLoading={isLoading} variant={variantButton} onClick={onOk} block>{okButtonText}</Button>
        {footerComponent}
      </div>
    </Container>
  )
}

export default Modal
